import React from 'react';


function PasswordChangeSection(props) {
  const {
    isCam4User,
    handleChange,
    email,
    password,
    passwordError,
    passwordErrorVisible,
    confirmPassword,
  } = props;

  if (isCam4User) {
    return (
      <div className="cam4-user-password-change">
        CAM4 Gold Members can change their password on CAM4
      </div>
    );
  }

  return (
    <React.Fragment>
      <div
        className="password input optional stringish form-group"
        id="customer_password_input"
      >
        <input
          id="username"
          style={{ display: 'none' }}
          value={email}
        />
        <label
          className="control-label"
          htmlFor="customer_password"
        >
          New password
        </label>
        <div>
          <input
            className="form-control"
            id="customer_password"
            name="customer[password]"
            placeholder="Password"
            type="password"
            value={password}
            onChange={handleChange('password')}
          />
          <span className="help-inline">
            Your password must be at least 8
            characters long, must be different than
            your username, and may not start with
            &apos;nakednews&apos; or &apos;password&apos;
          </span>

          {passwordErrorVisible && <p style={{ color: 'red', marginBottom: '0' }}>{passwordError}</p>}
        </div>
      </div>
      <div
        className="password input optional stringish form-group"
        id="customer_password_confirmation_input"
      >
        <label
          className="control-label"
          htmlFor="customer_password_confirmation"
        >
          Confirm new password
        </label>
        <div>
          <input
            className="form-control"
            id="customer_password_confirmation"
            name="customer[password_confirmation]"
            placeholder="Password confirmation"
            type="password"
            value={confirmPassword}
            onChange={handleChange(
              'confirmPassword'
            )}
          />
          <span className="help-inline">
            This must be the same as your new
            password
          </span>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PasswordChangeSection;
